/**
 * STT Chunk API
 * Handles speech-to-text chunked transcription endpoints
 */

import { executeRequest } from './hooks/useApiQuery';

export interface ChunkRequest {
  id: string;
  audio: string;
  chunkIndex: number;
  mimetype?: string;
}

export interface ChunkResponse {
  success: boolean;
  error?: string;
  text?: string;
  accumulatedText?: string;
}

/**
 * Sends an audio chunk for transcription
 */
export async function sendChunk(request: ChunkRequest): Promise<ChunkResponse> {
  return executeRequest<ChunkResponse>({
    url: '/stt-chunk/chunk',
    method: 'POST',
    body: request,
  });
}

/**
 * Sends the final audio chunk and triggers final processing
 */
export async function sendFinalChunk(request: ChunkRequest): Promise<ChunkResponse> {
  return executeRequest<ChunkResponse>({
    url: '/stt-chunk/final_submit',
    method: 'POST',
    body: request,
  });
}
